import { Configuration } from '@/generated'
import { AuthenticationService } from '@/services/AuthenticationService'

const API_BASE_PATH = '/api'
export const globalApiConfig: Configuration = new Configuration({
  accessToken: AuthenticationService.updateAccessToken,
  basePath: API_BASE_PATH
})
